import React, { useState } from 'react';
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Popover,
  Select,
  Switch,
} from 'antd';
import {
  createMacroBackgroundAdmin,
  createMarketHours,
  createPreset,
  createUnderlyingAsset,
  instrumentTypes,
  marketHours,
  REGIONS,
  selectors,
  UnderlyingAsset,
} from 'state';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import { auctions_tenors } from '../../../state/app/auctions/types';
import {
  CDS_FREQUECIES,
  TENOR_UNITS,
} from '../../../state/app/repos/constants';

const { TextArea } = Input;

type Props = {
  hide: () => void;
};
const CreateMacroBackgroundModal: React.FC<Props> = ({ hide }) => {
  const dispatch = useDispatch();
  const [presetName, setPresetName] = useState('');
  const [body, setBody] = useState('');
  const waitingPresets = useSelector(selectors.presetsWaiting);
  return (
    <Modal
      open={true}
      onOk={hide}
      onCancel={hide}
      title={'Create a new Macro Background'}
      width={800}
      footer={null}
    >
      <div
        style={{
          // display: 'flex',
          // flexDirection: 'column',
          textAlign: 'right',
        }}
      >
        <Input
          value={presetName}
          onChange={e => {
            setPresetName(e.target.value);
          }}
          placeholder="Preset Name"
        />
        <TextArea
          placeholder="Body"
          style={{ minHeight: '60vh' }}
          value={body}
          onChange={e => setBody(e.target.value)}
        />
        <Button
          loading={waitingPresets}
          style={{ marginTop: 15 }}
          type="primary"
          disabled={!presetName}
          onClick={() => {
            dispatch(
              createMacroBackgroundAdmin({ name: presetName, body: body })
            );
            // hide();
          }}
        >
          Create
        </Button>
      </div>
    </Modal>
  );
};
export default CreateMacroBackgroundModal;
